
/*
 * facecloud后台index页面
 * @Author: ljb
 * @Date: 2018-03-26 10:18:23
 * @Last Modified by: ljb
 * @Last Modified time: 2020-01-22 17:27:45
 */
<style lang="less" rel="stylesheet/less" type="text/less">
.leftNavigation {
  i {
    font-size: 18px;
  }

}
</style>
<template>
	<div class="leftNavigation">
		<Col class="leftNavigation">
		<Menu
			theme="light"
			mode="vertical"
			class="leftNavigation"
			style="width:100%;overflow-y: scroll;"
			@on-select="toPath"
            accordion
		>
		<Submenu name="financial-center">
            <template slot="title">
			    <Icon type="logo-usd" />财务中心
            </template>
            <MenuItem name="recharge-center">
				<Icon type="logo-yen" />充值
          </MenuItem>
        </Submenu>
			<Submenu name="APP-management">
				<template slot="title">
					<Icon type="ios-paper" />应用管理
				</template>
				<MenuItem name="api-key">
				<Icon type="ios-key" />API KEY
          </MenuItem>

			</Submenu>

           </Submenu>

			<MenuItem name="api-book">
				<Icon type="ios-book" />Api文档
          </MenuItem>

			<Submenu name="face">
				<template slot="title">
					<Icon type="ios-person-add" />人脸识别
				</template>
                <MenuItem name="detect">
				    <Icon type="ios-person" />人脸检测
                </MenuItem>
				<MenuItem name="agegender">
				    <Icon type="md-people" />人脸年龄性别检测
                </MenuItem>
				<MenuItem name="detecthead">
			    	<Icon type="ios-people" />人头检测
                </MenuItem>
				<MenuItem name="emotion">
			     	<Icon type="md-person-add" />表情识别
                </MenuItem>
				<MenuItem name="faceaging">
	    			<Icon type="ios-person-outline" />人脸老化
                </MenuItem>
				<MenuItem name="facecompare">
		    		<Icon type="md-people" />人脸对比
                </MenuItem>
				<MenuItem name="generate_3d_model">
			     	<Icon type="ios-people-outline" />人脸三维重建
                </MenuItem>
				<MenuItem name="haircolor">
				    <Icon type="ios-color-palette" />头发染色
                </MenuItem>
			   <MenuItem name="hairsegement">
		 		    <Icon type="ios-color-palette-outline" />头发分割
                </MenuItem>
	     	    <MenuItem name="landmarks">
				    <Icon type="ios-man-outline" />人脸关键点检测
                </MenuItem>
			    <MenuItem name="makeupswap">
			    	<Icon type="md-people" />妆容迁移
                </MenuItem>
			    <MenuItem name="swapface">
				    <Icon type="ios-people" />人脸融合
                </MenuItem>
			    <MenuItem name="texture-swap-3d">
				    <Icon type="ios-people-outline" />3D人脸融合
                </MenuItem>
				<MenuItem name="beautyrank">
				    <Icon type="md-walk" />颜值评分
                </MenuItem>
				<MenuItem name="skinclassify">
				    <Icon type="ios-outlet-outline" />肤色分类
                </MenuItem>
                <MenuItem name="imagemakeup">
				    <Icon type="ios-images-outline" />照片上妆
                </MenuItem>
				<MenuItem name="skinrun">
				    <Icon type="ios-person" />肤质检测
				</MenuItem>
			</Submenu>

            <Submenu name="try-on">
	            <template slot="title">
	             			<Icon type="ios-paper" />人脸试戴
	             </template>
	             <MenuItem name="try-on-glasses">
	             		   <Icon type="md-glasses" />眼镜试戴
                 </MenuItem>
                <!-- <MenuItem name="3d">
                 		   <Icon type="md-glasses" />3d眼镜试戴
                 </MenuItem> -->
                <!-- <MenuItem name="hairstyle-try">
	             		   <Icon type="ios-key" />发型试戴
                 </MenuItem> -->

	        </Submenu>

			<Submenu name="material">
			    <template slot="title">
			     			<Icon type="ios-paper" />素材管理
			     </template>
			     <MenuItem name="material-Glasses-to-try">
			     		   <Icon type="md-glasses" />2D眼镜试戴素材
			     </MenuItem>
			<!--    <MenuItem name="3D-glasses-trial-material">
			     		   <Icon type="md-glasses" />3D眼镜试戴素材
			     </MenuItem> -->

			</Submenu>

		</Menu>
    </Col>
	</div>
</template>

<script type="text/babel">
import qs from 'qs';

export default {
	methods: {
		// 跳转路由并且提交跳转的name到vuex,并备份到sessionStorage
		toPath(path) {
            var thct = this;
            var title_ = false;
			thct.$router.push({ name: `${path}` });
			thct.$store.commit('addList',path);

            // for(var i=0;i<thct.$router.options.routes[3].children.length;i++){
            //     if(thct.$router.options.routes[3].children[i].title_box){
            //         if(thct.$router.options.routes[3].children[i].path==path){
            //             title_ =true;
            //             thct.$store.commit('addList', thct.$router.options.routes[3].children[i].title_box.title);
            //         }

            //     }

            // }
            // if(!title_){
            //     thct.$store.commit('addList',path);
            // }

			sessionStorage.setItem(
				'breadcrumbList',
				JSON.stringify([{ name: path }]),
			);
		},
	},
};
</script>
